import makeStyles from 'e100-react-components/lib/styles/makeStyles';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    height: `${spacing(0.25)}`
  }
}));

export default useStyles;
